import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";

const MusicGenresModal = ({ show, handleClose, selectedGenres, allGenres, onSave }) => {
    const [search, setSearch] = useState("");
    const [selectedGenresIds, setSelectedGenresIds] = useState([]);

    // Sync selectedGenresIds with selectedGenres whenever they change or modal opens
    useEffect(() => {
        const initialSelectedIds = selectedGenres.map(g => (typeof g === 'object' ? g.id : g));
        setSelectedGenresIds(initialSelectedIds);
    }, [selectedGenres, show]);

    // Debug logging
    console.log('MusicGenresModal - allGenres:', allGenres);
    console.log('MusicGenresModal - selectedGenres:', selectedGenres);
    console.log('MusicGenresModal - selectedGenresIds:', selectedGenresIds);

    const filteredGenres = allGenres.filter(g =>
        g.label.toLowerCase().includes(search.toLowerCase())
    );

    const toggleGenre = (genreId) => {
        let newSelection;
        if (selectedGenresIds.includes(genreId)) {
            newSelection = selectedGenresIds.filter(id => id !== genreId);
        } else {
            newSelection = [...selectedGenresIds, genreId];
        }
        setSelectedGenresIds(newSelection);
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            contentClassName="campaign-card border-0 shadow-lg"
            size="lg"
        >
            <Modal.Header className="border-0 pb-0 d-flex align-items-center">
                <div className="d-flex align-items-center gap-3">
                    <div className="icon-box-premium" style={{ width: '45px', height: '45px', fontSize: '1.2rem' }}>
                        <i className="fa-solid fa-music text-primary"></i>
                    </div>
                    <div>
                        <Modal.Title className="fs-5 fw-bold mb-0">Géneros de Música</Modal.Title>
                        <p className="text-muted small mb-0">Seleciona os estilos que definem o teu evento.</p>
                    </div>
                </div>
                <button
                    type="button"
                    className="btn btn-sm rounded-circle d-flex align-items-center justify-content-center ms-auto border-0 bg-white bg-opacity-10 hover-scale"
                    onClick={handleClose}
                    style={{
                        width: '36px',
                        height: '36px',
                        transition: 'all 0.2s ease'
                    }}
                >
                    <i className="fa-solid fa-xmark text-white fs-5"></i>
                </button>
            </Modal.Header>
            <Modal.Body className="py-4">
                <div className="mb-4">
                    <div className="position-relative">
                        <i className="fa-solid fa-magnifying-glass position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                        <input
                            type="text"
                            className="form-control glass-input ps-5 py-2"
                            placeholder="Pesquisar género..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>
                </div>

                <div className="d-flex flex-wrap gap-2 max-vh-50 overflow-auto pe-2 custom-scrollbar">
                    {filteredGenres.length > 0 ? (
                        filteredGenres.map((genre) => {
                            const isSelected = selectedGenresIds.includes(genre.id);
                            return (
                                <div
                                    key={genre.id}
                                    onClick={() => toggleGenre(genre.id)}
                                    className={`campaign-status cursor-pointer border-1 transition-all px-3 py-2 ${isSelected
                                        ? "status-active border-primary bg-primary bg-opacity-10 shadow-sm"
                                        : "status-expired border-white border-opacity-10 opacity-75 grayscale-0"
                                        }`}
                                    style={{
                                        borderRadius: '12px',
                                        fontSize: '0.8rem',
                                        userSelect: 'none'
                                    }}
                                >
                                    {isSelected && <i className="fa-solid fa-check-circle me-1 scale-in"></i>}
                                    {genre.label}
                                </div>
                            );
                        })
                    ) : (
                        <div className="w-100 text-center py-5 opacity-50">
                            <i className="fa-solid fa-music fs-1 mb-3"></i>
                            <p>Nenhum género encontrado para "{search}"</p>
                        </div>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer className="border-0 pt-0">
                <button
                    className="btn-action btn-campaign-primary py-2 px-5 w-auto"
                    onClick={() => onSave(selectedGenresIds)}
                >
                    Guardar
                </button>
            </Modal.Footer>
        </Modal >
    );
};

export default MusicGenresModal;
